/* global gtag*/

import {$html} from '../../helpers/helpers';

export class Controls {
	constructor(game) {
		this.game = game;
		this.pause = document.getElementById('pause');
		this.info = document.getElementById('info');
		this.about = document.querySelector('#about button');
		this.sound = document.getElementById('sound');
		this.spacePress = false;

		this.aboutOpen = false;

		this.pause.addEventListener('click', this.handlerPause.bind(this));
		this.info.addEventListener('click', this.handlerInfo.bind(this));
		this.about.addEventListener('click', this.handlerAbout.bind(this));
		this.sound.addEventListener('click', this.handlerSound.bind(this));

		this.initKeybord();
	}

	// eslint-disable-next-line class-methods-use-this
	changeState(btn, isActive) {
		if (isActive) {
			btn.classList.add('is-active');
		} else {
			btn.classList.remove('is-active');
		}

		btn.blur();
	}

	handlerPause() {
		if (this.game.state === 'play') {
			this.game.pause();
		} else {
			this.game.play();
		}

		// analytic
		gtag('event', 'bottom_menu_click', {
			event_label: 'pause ',
		});
	}

	handlerAbout() {
		if (!this.aboutOpen) {
			this.about.parentNode.classList.add('is-active');
			this.game.pause();
			this.aboutOpen = true;
			this.about.blur();
		} else {
			this.about.parentNode.classList.remove('is-active');
			this.aboutOpen = false;
			this.about.blur();
		}

		// analytic
		gtag('event', 'bottom_menu_click', {
			event_label: 'info ',
		});
	}

	handlerSound() {
		if (!this.game.sound.soundOff) {
			this.changeState(this.sound, true);
			this.game.sound.off();
		} else {
			this.changeState(this.sound, false);
			this.game.sound.on();
		}

		// analytic
		gtag('event', 'bottom_menu_click', {
			event_label: 'mute',
		});
	}

	handlerInfo() {
		this.info.blur();
		this.game.popupMain.openInfo();

		// analytic
		gtag('event', 'bottom_menu_click', {
			event_label: 'rules',
		});
	}

	addHoverClass() {
		this.game.coin.infoBlock.btn.classList.add('js-hover');
		this.pause.classList.add('js-hover');
		this.game.popupMain.button.classList.add('js-hover');

		setTimeout(() => {
			this.game.coin.infoBlock.btn.classList.remove('js-hover');
			this.pause.classList.remove('js-hover');
			this.game.popupMain.button.classList.remove('js-hover');
		}, 300);
	}

	eventContinue() {
		if (this.game.state === 'pause' && this.game.start) {
			this.game.play();
			this.addHoverClass();
		}
	}

	initKeybord() {
		window.addEventListener('keydown', (e) => {
			if (e.key === ' ') {
				if (!this.spacePress) {
					this.spacePress = true;
					this.game.player.jump();

					this.eventContinue();
				}
			} else if (e.key === 'Enter' || e.key === 'Escape') {
				this.eventContinue();
			}
		});

		window.addEventListener('keyup', (e) => {
			if (e.key === ' ') {
				this.spacePress = false;
			}
		});

		this.game.canvas.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();

			if (window.innerWidth < 1024 || $html.classList.contains('is-device-tablet')) {
				this.game.player.jump();
			}
		});
	}
}
